import { render } from "./BookmarkToggle.vue?vue&type=template&id=aa406780"
import script from "./BookmarkToggle.vue?vue&type=script&lang=js"
export * from "./BookmarkToggle.vue?vue&type=script&lang=js"
script.render = render

export default script